export const GOOGLE_MAPS_API_KEY = 'AIzaSyDUnmEGqix9gziZQjtCQFJ7mCTSDV9yPDk';
export const AMPLITUDE_API_KEY = 'eade10d6f4746cbe34333e42ff653fbc';

/** Mapbox public token for Static Images (report hero). Restrict in Mapbox dashboard (URLs / scopes); do not use sk.* here. */
export const MAPBOX_ACCESS_TOKEN =
  'pk.eyJ1IjoiamFlc2Vva2FuOTQiLCJhIjoiY21uM3hodGttMWNjcTJwc2ZoeWFhbHVjaiJ9.Yl9nAx9KiquwABKdcFq5nQ';
